import { useEffect, useLayoutEffect } from "react";
import { resetSocketState } from "src/redux/reducers/socketSlice";
import { useAppDispatch, useAppSelector } from "src/redux/redux-hooks";
import eventSocket from "src/sockets/eventSocket";
import fancySocketServices from "src/sockets/fancySocketServices";
import socketServices, { socket } from "src/sockets/socketService";
import sportSocket from "src/sockets/sportSocket";
import userSocket from "src/sockets/userSocket";

const useReConnectOnTabChange = ({ handleConnect }: { handleConnect: () => void }) => {
  const dispatch = useAppDispatch();
  const { oddsSocketConnected } = useAppSelector(({ socket }) => socket);

  const handleDisconnect = () => {
    console.log("Disconnecting all sockets");
    dispatch(resetSocketState());

    setTimeout(() => {
      userSocket.disconnect();
      eventSocket.disconnect();
      fancySocketServices.disconnect2();
      sportSocket.disconnect();

      socketServices.disconnect2();
    }, 500);
  };

  useLayoutEffect(() => {
    return () => {
      handleDisconnect();
    };
  }, []);

  const handleResume = () => {
    setTimeout(() => {
      if (handleConnect) handleConnect();
    }, 500);
  };

  const onPageShow = (e: PageTransitionEvent) => {
    if (e.persisted) {
      console.info("RENDER from MEMORY");
      handleResume();
    }
  };

  const onVisible = () => {
    console.log("🚀 document.visibilityState:", document.visibilityState);
    if (document.visibilityState === "visible") {
      console.log("Connect After Tab Change");
      handleResume();
    } else {
      handleDisconnect();
    }
  };

  const onOnline = () => {
    console.log("Connect After System Online");
    handleResume();
  };

  useEffect(() => {
    document.addEventListener("visibilitychange", onVisible);
    window.addEventListener("pageshow", onPageShow);
    window.addEventListener("online", onOnline);

    return () => {
      document.removeEventListener("visibilitychange", onVisible);
      window.removeEventListener("pageshow", onPageShow);
      window.removeEventListener("online", onOnline);
    };
  }, [oddsSocketConnected]);

  useEffect(() => {
    if (oddsSocketConnected) {
      // socket?.on('disconnect', function (reason) {
      //   console.info('🚀 ~ useReConnect ~ disconnect:', reason);

      //   if (['io server disconnect', 'ping timeout'].includes(reason)) {
      //     // userSocket.disconnect();
      //     // dispatch(resetSocketState());

      //     setTimeout(() => {
      //       if (handleConnect) handleConnect();
      //     }, 100);
      //   }
      // });

      const interval = setInterval(() => {
        // console.log('heartbeat');
        socket.emit("heartbeat");
      }, 20000);

      return () => {
        clearInterval(interval);
      };
    }
  }, [oddsSocketConnected]);

  return null;
};

export default useReConnectOnTabChange;
